<template>
  <dynamic-form
    class="box"
    :schema="schema"
  >
    <header>
      <h1 class="box__title">
        {{ $t('dashboard.dashboard') }}
      </h1>

      <p class="box__sub-title">
        {{
          $t('dashboard.overall_summary', {
            workspace: getCurrentWorkspace?.name,
            service: getCurrentService?.name,
          })
        }}
      </p>
    </header>
    <dynamic-field
      v-bind="filterInputData"
      class="select"
      @get:model-value="applyFilters"
    />
  </dynamic-form>
</template>

<script>
  import { mapState, mapWritableState } from 'pinia';

  import DynamicField from '@/components/SharedComponents/DynamicField/DynamicField.vue';
  import DynamicForm from '@/components/SharedComponents/DynamicForm/DynamicForm.vue';
  import { userDetailsStore } from '@/stores/auth/user-details.store';
  import { useDashboardStore } from '@/stores/reports/dashboard.store';
  import { livePanelStore } from '@/stores/socket/live-panel-socket.store';
  export default {
    name: 'DashboardSubHeader',
    components: {
      DynamicForm,
      DynamicField,
    },

    emits: {
      onFilter: (value) => {
        if (value.length) {
          return true;
        } else {
          console.warn('Invalid onFilter event payload!');
          return false;
        }
      },
    },

    data() {
      return {
        schema: {
          filter: {},
        },
      };
    },
    methods: {
      applyFilters({ value }) {
        this.selectedQueues = value.map((item) => item.number);
      },
    },
    computed: {
      ...mapState(livePanelStore, ['queuesArray']),
      ...mapWritableState(useDashboardStore, ['selectedQueues', 'summary']),
      ...mapState(userDetailsStore, ['getCurrentWorkspace', 'getCurrentService']),

      queues() {
        // sums outbound queues and inbound queues
        const outboundQueues = Object.values(this.summary)
          .filter((item) => item.type === 'outbound')
          .map((queue) => ({
            ...queue,
            name: queue.queue,
            number: queue.queue,
          }));

        const inboundQueues = this.queuesArray.map((queue) => ({
          ...queue,
          name: `${queue.name} (${queue.number})`,
        }));

        return [...inboundQueues, ...outboundQueues];
      },

      filterInputData() {
        return {
          type: 'select',
          name: 'filter',
          placeholder: `${this.$t('call_center.filter_by')} ${this.$t('call_center.filter_by_type.queues')}`,
          multiple: true,
          items: this.queues,
          label: 'name',
          trackBy: 'number',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box {
    margin-bottom: 16px;
    border-radius: var(--mainRadius);
    background-color: var(--shadesWhite);
    padding: 12px 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include responsive(max, 768px) {
      padding: 8px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    &__title {
      color: var(--gray900);
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 8px;

      @include responsive(max, 768px) {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
        margin-bottom: 4px;
      }
    }

    &__sub-title {
      color: var(--gray500);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;
    }
    .select {
      min-width: 20rem;
    }
  }
</style>
